<template>
  <div>
    <transition name="slide-fade">
      <cardFeed class="cardFeed" v-if="show" :groups="groups" :zoom="zoom" :center="center" />
    </transition>

    <transition name="slide-fade">
      <md-button class="toggle" :md-ripple="false" @click="show = !show" v-if="show">
        <md-icon class="arrowLeft md-size-2x">arrow_left</md-icon>
        <md-icon class="arrowDropDown md-size-2x">arrow_drop_down</md-icon>
      </md-button>
    </transition>

    <transition name="slide-fade-btn">
      <md-button class="toggleBtn md-small" :md-ripple="false" @click="show = !show" v-if="!show">
        <md-icon class="arrowRight md-size-2x">arrow_right</md-icon>
        <md-icon class="arrowDropUp md-size-2x">arrow_drop_up</md-icon>
      </md-button>
    </transition>
  </div>
</template>

<script>
import cardFeed from "./cards/cardFeed.vue";
import bus from "@/api/bus";

export default {
  name: "sidebarMapview",
  components: {
    cardFeed
  },
  props: ["groups", "zoom", "center"],
  data() {
    return {
      show: false
    };
  },
  mounted() {
    bus.on.createFromSidebar(() => this.show = false);
  },
};
</script>

<style scoped>
.cardFeed {
  position: initial;
  width: auto;
  height: -webkit-fill-available;
  overflow-y: auto;
  z-index: 1;
}

#btnControl {
  display: none;
}

.btn {
  position: absolute;
  top: 5em;
  left: 29%;
  width: 10%;
  text-align: center;
  text-decoration: none;
  margin: 0 auto;
  z-index: 1;
  cursor: pointer;
  color: #000;
  background-color: #fff;
  padding: 11px;
  border: 1px solid transparent;
  border-radius: 2px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  outline: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  /* alignment-baseline:central; */

  /* -webkit-transition: all .5s ease-in-out; */
  transition: all 500ms cubic-bezier(0, 0, 0.58, 1);
  -webkit-user-select: none;
}

#btnControl:checked + label {
  position: absolute;
  transition: all ease 700ms;
  transform: translateX(-400px);
}

.toggleBtn:active {
  opacity: 0;
  transition: all 550ms cubic-bezier(0, 0, 0.58, 1);
  transform: translateX(15px);
}

/* .slide-fade-btn-leave{
    opacity: 0;
    transform: translateX(200px);
    transition: all 550ms cubic-bezier(0.000, 0.000, 0.580, 1.000);
  } */

/* Quando clicar para voltar */
.slide-fade-enter-active{
  transition: all 550ms cubic-bezier(0.000, 0.000, 0.580, 1.000);
}

/* Quando clicar para fechar */
.slide-fade-leave-active{
  transition: all 800ms cubic-bezier(0.000, 0.000, 0.580, 1.000);
}

.arrowRight, .arrowDropUp{
  color: #fff!important;
}

.md-size-2x{
  width: 28px;
  min-width: 28px;
}

@media (min-width:452px) {

  .arrowDropDown{
    display: none;
  }

  .arrowDropUp{
    display: none;
  }

  .toggle{
    position: relative;
    height: 12%;
    min-width: 5%;
    top: 5em;
    float: left;
    margin: 0;
    z-index: 2;
    background-color: #fff;
  }

  .toggleBtn{
    position: absolute;
    height: 12%;
    min-width: 8%;
    top: 5em;
    left: 0;
    margin: 0;
    z-index: 2;
    background-color: #11999e;
  }

  .toggleBtn:active{
    opacity: 0;
    transition: all 550ms cubic-bezier(0.000, 0.000, 0.580, 1.000);
    transform: translateX(15px);
  }

  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(-1200px);
  }

}

@media (max-width:451px) {

  .arrowLeft{
    display: none;
  }

  .arrowRight{
    display: none;
  }

  .cardSidebar {
    display: flex;
    position: absolute;
    height: 100%;
    width: 100%;
  }

  .cardFeed {
    position: absolute;
    width: 100%;
    z-index: 3;
    margin: 0 auto;
  }

  .toggle{
    position: relative;
    height: 8%;
    width: 100%;
    top: 0;
    float: left;
    margin: 0 0.4em 0 0;
    z-index: 3;
    border-bottom: 2px solid #f5f5f5;
    background-color: #fff;
  }

  .toggleBtn{
    position: fixed;
    bottom: 0;
    margin: 0 40%;
    z-index: 2;
    background-color: #11999e;
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;
  }

  .toggleBtn:active{
    opacity: 0;
    transition: all 550ms cubic-bezier(0.000, 0.000, 0.580, 1.000);
    transform: translateY(15px);
  }

  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(1000px);
  }
}

@media (max-width:375px) {

  .arrowLeft{
    display: none;
  }

  .arrowRight{
    display: none;
  }

  .cardFeed {
    position: absolute;
    width: 100%;
    height: -webkit-fill-available;
    overflow-y: auto;
    z-index: 3;
    margin: 0 auto;
  }

  .toggle{
    height: 8%;
    margin: 0 0.5em 0 0;

  }

  .toggleBtn{
    position: fixed;
    bottom: 0;
    margin: 0;
    z-index: 2;
    background-color: #11999e;
    margin: 0 10em;
  }

  .toggleBtn:active{
    opacity: 0;
    transition: all 550ms cubic-bezier(0.000, 0.000, 0.580, 1.000);
    transform: translateY(15px);
  }

  .slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(1000px);
}

}

@media (max-width:320px) {

  .arrowLeft{
    display: none;
  }

  .arrowRight{
    display: none;
  }

  .cardFeed {
    position: absolute;
    width: 100%;
    height: -webkit-fill-available;
    overflow-y: auto;
    z-index: 3;
    margin: 0 auto;
  }

  .toggleBtn{
    position: fixed;
    bottom: 0;
    margin: 0;
    z-index: 2;
    background-color: #11999e;
    margin: 0 8.5em;
  }

  .toggleBtn:active{
    opacity: 0;
    transition: all 550ms cubic-bezier(0.000, 0.000, 0.580, 1.000);
    transform: translateY(15px);
  }

  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(1000px);
  }

}
</style>
